module.exports = __webpack_public_path__ + "img/public/SiteIcons/viewMapIcon.svg?cbd32952";